import React from 'react';
import PropTypes from 'prop-types';
import Form from 'react-form-controlled';
import MessageDefinitions from '../i18n/MessageDefinitions';
import { FormattedMessage, intlShape } from 'react-intl';
import {connectToStores} from "fluxible-addons-react";
import {LocationShape} from "../../common/react/Shapes";

@connectToStores(['ContactMeStore'], (context, props) => {
  const ContactMeStore = context.getStore('ContactMeStore');
  return {
    selectedLocation: ContactMeStore.getSelectedLocation(),
    selectedTime: ContactMeStore.getSelectedTime(),
    lead: ContactMeStore.getLead()
  };
})
class AppointmentInformation extends React.Component {
  static propTypes = {
    lead: PropTypes.object,
    selectedLocation: LocationShape.required,
    selectedTime: PropTypes.object.isRequired,
    success: PropTypes.bool
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired,
    intl: intlShape
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const eventObject = document.createEvent("Event");
    eventObject.initEvent("appointmentSet", false, false);
    document.dispatchEvent(eventObject);
  }

  formSubmitted = state => {
    if (window.ignite.contactSubmitted) {
      window.ignite.contactSubmitted(true);
    }
  };

  render() {
    const { success, selectedLocation, selectedTime } = this.props;

    const dayFormat = { weekday: 'long', month: 'long',  year: 'numeric', day: 'numeric' };
    const timeFormat = { hour: 'numeric', minute: 'numeric' };

    //TODO: message needs to be customizable
    const message =
      success
        ? <div className="appointment-information">
            <h1 className="thankYouMessage"><FormattedMessage {...MessageDefinitions.appointmentThanksTitle} /></h1>
            <span className="thankYouText"><FormattedMessage {...MessageDefinitions.appointmentThanksText} /></span>
            <div className="timeAndLocation">
              <h2 className="dayString">{selectedTime.start.toLocaleDateString('en-US', dayFormat)}</h2>
              <h2 className="timeString">{selectedTime.start.toLocaleTimeString('en-US', timeFormat)}</h2>
              <h3 className="locationString">{selectedLocation.name}</h3>
              <h3 className="addressString">{selectedLocation.address}</h3>
              <h3 className="cityStateString">{selectedLocation.city}, {selectedLocation.state} {selectedLocation.postalCode}</h3>
            </div>
            <div className="customHtml"></div>
        </div>
        : <div>An error occurred while setting your appointment. Please try again</div>;

    const buttonMessage = <FormattedMessage {...MessageDefinitions.close} />;


    return (
        <Form className="form-container" onSubmit={this.formSubmitted}>
          <div className="form-body">
            {message}
          </div>
          <div className="form-actions">
            <button type="submit" className="btn btn-primary save close-button">
              {buttonMessage}
            </button>
          </div>
        </Form>
    );
  }
}

export default AppointmentInformation;



/** WEBPACK FOOTER **
 ** ./src/main/js/contactMe/components/AppointmentInformation.js
 **/